import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { SELF } from '../../../shared/constants';
import { useTypedSelector } from '../../../shared/hooks/useTypedSelector';
import { MediaStatus } from '../constants';
import { selectHasCameraPermission, selectHasMicrophonePermission } from '../features/permissions';
import { getParticipantById, selectIsPermissionsExtendedEnabled } from '../selectors';

/**
 * Статусы кнопок микрофона и камеры для локального участника: учёт mute и роли
 * (MediaStatus.BLOCKED при отзыве прав организатором при включённой расширенной ролевой модели).
 */
export const useLocalMediaButtonStatus = () => {
    const self = useTypedSelector((state) => getParticipantById(state, SELF));
    const isPermissionsExtendedEnabled = useSelector(selectIsPermissionsExtendedEnabled);
    const hasMicrophonePermission = useSelector(selectHasMicrophonePermission);
    const hasCameraPermission = useSelector(selectHasCameraPermission);

    return useMemo(() => {
        const isAudioMuted = !self?.audio || self?.audio?.muted;
        const isVideoMuted = !self?.video || self?.video?.muted;

        const audioStatus: MediaStatus = (() => {
            if (isPermissionsExtendedEnabled && !hasMicrophonePermission) {
                return MediaStatus.BLOCKED;
            }
            if (isAudioMuted) {
                return MediaStatus.MUTED;
            }
            return MediaStatus.UNMUTED;
        })();

        const videoStatus: MediaStatus = (() => {
            if (isPermissionsExtendedEnabled && !hasCameraPermission) {
                return MediaStatus.BLOCKED;
            }
            if (isVideoMuted) {
                return MediaStatus.MUTED;
            }
            return MediaStatus.UNMUTED;
        })();

        return { audioStatus, videoStatus, isAudioMuted, isVideoMuted };
    }, [self, isPermissionsExtendedEnabled, hasMicrophonePermission, hasCameraPermission]);
};
